import * as derived from "./derived";

/**
 * Subject selectors namespace
 *
 * Usage:
 * - subjects.selectedElementsCount(uids)(state) - Count selected elements
 * - subjects.currentSubject(uids, isPCB)(state) - Get current subject
 * - subjects.selectedSubjectProperties(uids)(state) - Get merged properties
 */
export const subjects = {
    ...derived,
} as const;

export type SubjectsSelectors = typeof subjects;
